import { ResponseError } from '@backstage/errors';






import { NotFoundError } from '@backstage/errors';

/**
 * Options for creating a todo client.
 *
 * @public
 */





/**
 * An implementation of the AccessControlApi that talks to the access-control-backend plugin.
 *
 * @public
 */
export class AccessControl  {
    discoveryApi;
    identityApi;

  constructor(options) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  async getPermissionsByGroup(groupId) {
    const baseUrl = await this.discoveryApi.getBaseUrl('access');
    const { token } = await this.identityApi.getCredentials();

    const res = await fetch(`${baseUrl}/v1/group/${groupId}`, {
      method: 'GET',
      headers: token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : undefined,
    });

    if (!res.ok) {
      if (res.status === 404) throw new NotFoundError();
      else throw await ResponseError.fromResponse(res);
    }

    const data = await res.json();
    return data;
  }

  async getPermissionsByUser(userId) {
    const baseUrl = await this.discoveryApi.getBaseUrl('access');
    const { token } = await this.identityApi.getCredentials();

    const res = await fetch(`${baseUrl}/v1/user/${userId}`, {
      method: 'GET',
      headers: token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : undefined,
    });

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }

    const data = await res.json();
    return data;
  }

  async addPermission(newPermission) {
    const baseUrl = await this.discoveryApi.getBaseUrl('access');
    const { token } = await this.identityApi.getCredentials();

    const res = await fetch(`${baseUrl}/v1`, {
      method: 'POST',
      headers: token
        ? {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        : undefined,
      body: JSON.stringify(newPermission),
    });

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }

    const data = await res.json();
    return data;
  }

  async updatePermission(
    ownerId,
    uuid,
    newPermission,
  ) {
    const baseUrl = await this.discoveryApi.getBaseUrl('access');
    const { token } = await this.identityApi.getCredentials();

    const res = await fetch(`${baseUrl}/v1/${ownerId}/${uuid}`, {
      method: 'PUT',
      headers: token
        ? {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        : undefined,
      body: JSON.stringify(newPermission),
    });

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }
  }

  async deletePermission(ownerId, uuid) {
    const baseUrl = await this.discoveryApi.getBaseUrl('access');
    const { token } = await this.identityApi.getCredentials();

    const res = await fetch(`${baseUrl}/v1/${ownerId}/${uuid}`, {
      method: 'DELETE',
      headers: token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : undefined,
    });

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }
  }
}
